import {countryConfig} from 'src/country-config/country-config';
import {ProductVariant} from './products';
import {ShippingAddress, ShippingDimensions} from '../../marketplace-courier/requests/shipping-req';

export class Product {
  description;
  detailDescription;
  quantitySold;
  pum;
  urlImage;
  id;
  totalStock;
  offerText;
  offerPrice;
  offerDescription;
  mediaImageUrl;
  seoUrl = '';
  url2: string;
  url: string;
  petalText;
  petalColor;
  petalType;
  primeDescription?: string;
  primePrice?: number;
  primeTextDiscount?: string;
  isMarketPlace: boolean = false;
  sellerMarketPlace: string = '';
  deliveryTimeMarketPlace: string = '';
  variants: Array<ProductVariant> = [];
  productType?: string = null;
  dimensions?: ShippingDimensions;
  sellerAddresses?: Array<ShippingAddress>;
  hasStock?:boolean;

  constructor(product: any) {
    Object.assign(this, {...product});
    this.primeDescription = product?.primeDescription;
    this.primePrice = product?.primePrice;
    this.primeTextDiscount = product?.primeTextDiscount;
    this.description = product?.mediaDescription || product?.description;
    this.detailDescription = product?.grayDescription || product?.detailDescription;
    this.quantitySold = product?.quantity || product?.quantitySold;
    this.mediaImageUrl = product?.mediaImageUrl || product?.imageUrl;
    this.primeDescription = product?.primeDescription;
    this.primePrice = product?.primePrice;
    this.primeTextDiscount = product?.primeTextDiscount;
    this.id = parseInt(product?.id || product?.objectID, 10);
    this.seoUrl = this.urlFormatter(this.description);
    this.variants = product?.variants;
    this.productType = product?.product_type;
    if (product?.labelPum && product?.measurePum && product?.measurePum > 0) {
      if (product.offerPrice && product.offerPrice > 0) {
        this.pum = `${product.labelPum} ${(product.offerPrice / product.measurePum).toFixed(2)}`;
      } else {
        this.pum = `${product.labelPum} ${(product.fullPrice / product.measurePum).toFixed(2)}`;
      }
    }
    if (product?.listUrlImages && product?.listUrlImages?.length > 0) {
      if (product.mediaImageUrl) {
        const idx = product.listUrlImages.indexOf(product.mediaImageUrl);
        if (idx > 0) {
          product.listUrlImages.splice(idx, 1);
        } else if (idx != 0) {
          product.listUrlImages.unshift(product.mediaImageUrl);
        }
        product.mediaImageUrl = product.listUrlImages[0];
      }
    }
    if (product?.type === 'GROUP' && (product?.first_description || product?.firstDescription)) {
      this.mediaImageUrl = product.url_image || product.urlImage;
      this.offerDescription = product.first_description || product.firstDescription;

      this.description = this.offerDescription;
      this.id = product.id_offer || product.id;
    }

    if (countryConfig.getService) {
      if (!product.allowedStock) {
        product.allowedStock = 20;
      }

      if (product.type !== 'GROUP') {
        this.totalStock = product.stock || product.totalStock || 0;
      }
      this.setPetalStatus(product);
    }
  }

  private hasSAG() {
    return localStorage.mobileSaG;
  }

  private urlFormatter = text => {
    if (!text) {
      return text;
    }

    let newRegx = text
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/´/g, '')
      .replace(/ /g, '-')
      .replace(/--/g, '-')
      .replace(/[\xa0]/g, '')
      .replace(/[&\/\\#,]/g, '')
      .replace(/[+()$~%.'"]/g, '')
      .replace(/[:=*?]/g, '')
      .replace(/[!<>{}]/g, '');
    return newRegx;
  };

  private setPetalStatus(product: any) {
    this.petalText = `Entrega promedio 90 mins`;
    this.petalType = 0;

    if (product.fullPrice < 0.01) {
      this.petalText = `No Disponible`;
      this.petalColor = '#940000';
      this.totalStock = 0;
      return false;
    }

    if (product.onlyOnline) {
      this.petalType = 4;
      this.totalStock = product.stock || product.totalStock;
      return false;
    }

    if (this.id == '0' || this.id == '1053709') {
      this.totalStock = product.stock || product.totalStock;
      return false;
    }

    if (this.totalStock > 0) {
      this.petalColor = '#008000';
    } else {
      this.petalColor = '#940000';
    }
    if ((product.greenStore || product.greenDelivery) && this.totalStock > 1) {
      this.petalColor = '#008000';
      if (product.greenStore) {
        this.totalStock = 0;
        this.petalText = 'Solo disponible en tienda';
        this.petalType = 2;
      }
      return;
    }
    if (product.availableOnline === false) {
      this.totalStock = 0;
      this.petalText = 'Solo disponible en tienda';
      this.petalType = 2;
    }
    if (product.noFullPrice) {
      this.totalStock = 0;
      this.petalText = 'Cómpralo llamando al <a href="tel:0800-327628636"> 0800-3276286</a>';
      this.petalType = 3;
    }
    if (product.availableOnline && product.noFullPrice) {
      this.totalStock = 0;
      this.petalText = 'Cómpralo llamando al <br/><a href="tel:0800-327628636"> 0800-3276286</a>';
      this.petalType = 4;
    }
  }
}
